import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../redux/slices/authSlice';
import { landingRouteFor } from './routeConfig';

// Restricts a route to specific user types.
// This is UX correctness, not security — the backend middleware is what
// actually enforces access. Never rely on this alone.
const RoleRoute = ({ children, allowedUserTypes }) => {
  const user = useSelector(selectUser);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedUserTypes.includes(user.userType)) {
    // Wrong portal — send them to their own.
    return <Navigate to={landingRouteFor(user.userType)} replace />;
  }

  return children;
};

RoleRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedUserTypes: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default RoleRoute;
